import React from 'react';
import PropTypes from 'prop-types';
import { RouteLink } from 'core/components';

export const BannerSliderItem = ({
  children,
  isBtnWithLink,
  isRelativeLink,
  buttonUrl,
  isNewTabLink,
  className,
  bonusId,
  minDeposit,
  activateBonus,
}) => {
  if (isBtnWithLink) {
    if (isRelativeLink) {
      return (
        <RouteLink
          className={className}
          to={buttonUrl}
        >
          {children}
        </RouteLink>
      );
    }

    return (
      <a
        href={buttonUrl}
        className={className}
        {...(isNewTabLink ? {
          target: '_blank',
          rel: 'noopener noreferrer'
        } : {})}
      >
        {children}
      </a>
    );
  }

  return (
    <div
      role="button"
      tabIndex="0"
      onClick={activateBonus}
      onKeyPress={activateBonus}
      data-id={bonusId}
      data-min={minDeposit}
      className={className}
    >
      {children}
    </div>
  );
};

BannerSliderItem.propTypes = {
  isBtnWithLink: PropTypes.bool.isRequired,
  isRelativeLink: PropTypes.bool.isRequired,
  isNewTabLink: PropTypes.bool.isRequired,
  buttonUrl: PropTypes.string.isRequired,
  bonusId: PropTypes.number,
  minDeposit: PropTypes.number,
  children: PropTypes.node.isRequired,
  activateBonus: PropTypes.func.isRequired,
  className: PropTypes.string,
};

BannerSliderItem.defaultProps = {
  className: '',
  bonusId: null,
  minDeposit: null,
};
